import { Flex, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { AddEntityLink, AddPersonLink, AddVenueLink } from "~pages/Dashboard/components";
import { DashboardSeasonList } from "./components/DashboardSeasonList/DashboardSeasonList.tsx";

const DashboardPage = () => {
  return (
    <Flex vertical gap={8}>
      <Typography.Title level={4} style={{ fontWeight: 400 }}>
        <FormattedMessage id="quickLinks" />
      </Typography.Title>
      <Flex wrap gap={20}>
        <AddEntityLink />
        <AddPersonLink />
        <AddVenueLink />
      </Flex>
      <DashboardSeasonList />
    </Flex>
  );
};

export default DashboardPage;
